export const state = () => ({
  // Holds the currently applied filters on page
  appliedPageFilters: [],

  // Holds BR Refs of widgets inside active cockpit tabs
  brRefsByCockpitUUID: {},

  // Holds BR Refs of widgets inside object template on page
  brRefsByObjectTemplateUUID: {},

  // Holds BR Refs of widgets on main dashboard
  dashboardBrRefs: [],

  // Distinct fields on page (fields present on all widgets)
  distinctFields: [],

  // Cache for distinct fields
  distinctFieldsCache: {},

  // Holds the model value for selected filter
  filterValueModel: {},

  // Page ref
  pageRef: null,

  // Preload filters of the dashboard(allowed filter)
  preloadFilters: [],

  // Holds current chart clicked for multi dim filter
  activeChartForMultiDimFilters: null,

  // Holds selected chart dim filters for multi dim selection
  selectedChartDimFilters: [],

  // Holds filters for access-control cockpit widget
  acWidgetFilters: {},

  //Holds the filter object which user want to undo from the applied filter
  undoFilters: [],

  //Holds the filter object which user want to redo
  redoFilters: [],

  // Flag for loading distinct fields
  loadingDistinctFields: false,

  // Flag to indicate distinct fields have completed loading at least once
  hasLoadedDistinctFields: false
});
